import {
  defineStyleConfig,
  StyleThemingProps,
  useStyleConfig,
} from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { getName } from '~/utils/objectUtils'

const {
  Background: { Page: PageColor },
} = themeColorSectionKeys.defaults

export const DetailPanelStyle = defineStyleConfig({
  baseStyle: {
    flexDirection: 'column',
    flex: '1 0 0',
    backgroundColor: PageColor,
  },
})

export const useDetailPanelStyle = (props?: StyleThemingProps) => {
  return useStyleConfig(getName({ DetailPanelStyle }), props)
}
